import { render } from "./ConnectionsRibbon.vue?vue&type=template&id=d68607f2"
import script from "./ConnectionsRibbon.vue?vue&type=script&lang=js"
export * from "./ConnectionsRibbon.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__